module.exports = __webpack_public_path__ + "img/vk-logo.92a34421.png";